/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Notification from "./../services/notification";

const MUTATIONS = {
  SET_NOTIFICATIONS: "setNotifications"
};

export default {
  namespaced: true,
  state: {
    notifications: null
  },
  getters: {
    notifications: state => state.notifications
  },
  mutations: {
    [MUTATIONS.SET_NOTIFICATIONS]: (state, notifications) => {
      state.notifications = notifications;
    }
  },
  actions: {
    async load({ commit }) {
      let list = await Notification.get();
      commit(MUTATIONS.SET_NOTIFICATIONS, list);
      return list;
    }
  }
};
